import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Mousewheel } from "swiper/core";
SwiperCore.use([Mousewheel]);

function Mod() {
	return (
		<div className="wrapper">
        <div className="page_wrapper">
            <div className="bg bs4">
                <div className="kv_part">
                    <img src={require("../../image/mod/kv.png").default} className="d-lg-inline-block d-none" alt="MOD+HiNet光世代" />
                    <img src={require("../../image/mod/kv-mo.png").default} className="d-lg-none d-inline-block" alt="MOD+HiNet光世代" />
                </div>
                <div className="container">
                    <span id="tab-1"></span>
                    <span id="tab-2"></span>
                    <div className="mod_tab" id="mod_tab" >
                        {/* 頁籤按鈕 */}
                        <ul>
                            <li>
                                <a href="#tab-1"> </a>
                            </li>
                            <li>
                                <a href="#tab-2"> </a>
                            </li>
                        </ul>
                        
                        {/* content */}
                        <div className="content">
                            <div className="tab-content-1">
                                <div className="row  align-items-center">
                                    <div className="col-lg-6 text-center">
                                        <img src={require("../../image/mod/tab01_title01.png").default} className="d-lg-inline-block d-none" alt="" />
                                        <img src={require("../../image/mod/tab01-m_title01.png").default} className="d-lg-none d-inline-block" alt="" />
                                    </div>
                                    <div className="col-lg-6">
                                        <img src={require("../../image/mod/content_tab01_01.jpg").default} alt=""/>
                                    </div>
                                </div>
                                <div className="row flex-row-reverse align-items-center">
                                    <div className="col-lg-6 text-center">
                                        <img src={require("../../image/mod/tab01_title02.png").default} className="d-lg-inline-block d-none" alt="" />
                                        <img src={require("../../image/mod/tab01-m_title02.png").default} className="d-lg-none d-inline-block" alt="" />
                                    </div>
                                    <div className="col-lg-6">
                                        <img src={require("../../image/mod/content_tab01_02.jpg").default} alt="" />
                                    </div>
                                </div>
                                <div className="row  align-items-center">
                                    <div className="col-lg-6 text-center">
                                        <img src={require("../../image/mod/tab01_title03.png").default} className="d-lg-inline-block d-none" alt="" />
                                        <img src={require("../../image/mod/tab01-m_title03.png").default} className="d-lg-none d-inline-block" alt="" />
                                    </div>
                                    <div className="col-lg-6">
                                        <img src={require("../../image/mod/content_tab01_03.jpg").default} alt="" />
                                    </div>
                                </div>
                                <div className="row flex-row-reverse align-items-center">
                                    <div className="col-lg-6 text-center">
                                        <img src={require("../../image/mod/tab01_title04.png").default} className="d-lg-inline-block d-none" alt="" />
                                        <img src={require("../../image/mod/tab01-m_title04.png").default} className="d-lg-none d-inline-block" alt="" />
                                    </div>
                                    <div className="col-lg-6">
                                        <img src={require("../../image/mod/content_tab01_04.jpg").default} alt="" />
                                    </div>
                                </div>
                                <div className="row  align-items-center">
                                    <div className="col-lg-6 text-center">
                                        <img src={require("../../image/mod/tab01_title05.png").default} className="d-lg-inline-block d-none" alt="" />
                                        <img src={require("../../image/mod/tab01-m_title05.png").default} className="d-lg-none d-inline-block" alt="" />
                                    </div>
                                    <div className="col-lg-6 Swiper_mod">
                                        <div className="scroll-items tab01-bg05">
                                            <Swiper
                                                direction={"vertical"}
                                                slidesPerView={1}
                                                mousewheel={true}
                                                modules={[Mousewheel]}
                                                className="mySwiper"
                                            >
                                                <SwiperSlide>
                                                    <img src={require("../../image/mod/content_tab01_5_01.png").default} alt="" />               
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <img src={require("../../image/mod/content_tab01_5_02.png").default} alt="" />
                                                </SwiperSlide>
                                            </Swiper>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-content-2">
                                <div className="row align-items-center">
                                    <div className="col-lg-6 text-center">
                                        <img src={require("../../image/mod/tab03-m_title03.png").default} className="d-lg-inline-block d-none" alt="" />
                                        <img src={require("../../image/mod/tab03-m_title03.png").default} className="d-lg-none d-inline-block" alt="" />
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="scroll-items tab04-bg01">
                                            <Swiper
                                                direction={"vertical"}
                                                slidesPerView={1}
                                                mousewheel={true}
                                                modules={[Mousewheel]}
                                            >
                                                <SwiperSlide>
                                                    <img src={require("../../image/mod/content_tab03_1_01.png").default} alt="" />
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <img src={require("../../image/mod/content_tab03_1_02.png").default} alt="" />
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <img src={require("../../image/mod/content_tab03_1_03.png").default} alt="" />
                                                </SwiperSlide>
                                            </Swiper>
                                        </div>
                                    </div>
                                </div>
                                <div className="row flex-row-reverse align-items-center">
                                    <div className="col-lg-6 text-center">
                                        <img src={require("../../image/mod/tab03_title03.png").default} className="d-lg-inline-block d-none" alt="" />
                                        <img src={require("../../image/mod/tab03-m_title01.png").default} className="d-lg-none d-inline-block" alt="" />
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="scroll-items tab02-bg01">
                                            <Swiper
                                                direction={"vertical"}
                                                slidesPerView={1}
                                                mousewheel={true}
                                                modules={[Mousewheel]}
                                            >
                                                <SwiperSlide>
                                                    <img src={require("../../image/mod/content_tab03_3_01.png").default} alt="" />
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <img src={require("../../image/mod/content_tab03_3_02.png").default} alt="" />
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <img src={require("../../image/mod/content_tab03_3_03.png").default} alt="" />
                                                </SwiperSlide>
                                            </Swiper>
                                        </div>
                                    </div>
                                </div>
                                <div className="row align-items-center">
                                    <div className="col-lg-6 text-center">
                                        <img src={require("../../image/mod/tab03_title02.png").default} className="d-lg-inline-block d-none" alt="" />
                                        <img src={require("../../image/mod/tab03-m_title02.png").default} className="d-lg-none d-inline-block" alt="" />
                                    </div>
                                    <div className="col-lg-6 text-center">
                                        <div className="scroll-items tab04-bg02">
                                            <Swiper
                                                direction={"vertical"}
                                                slidesPerView={1}
                                                mousewheel={true}
                                                modules={[Mousewheel]}
                                            >
                                                <SwiperSlide>
                                                    <img src={require("../../image/mod/content_tab03_2_01.png").default} alt="" />
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <img src={require("../../image/mod/content_tab03_2_02.png").default} alt="" />
                                                </SwiperSlide>
                                            </Swiper>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p className="tips">
                        頻道節目表由營運商提供，如有異動以實際播出為準。
                    </p>
                </div>
            </div>
        </div>
    </div>
	)
}

export default Mod;